import {
  UsersIcon,
  TargetIcon,
  VideoIcon,
  PackageIcon,
  BoxIcon,
  BriefcaseIcon,
} from 'lucide-react'

export type OutcomeEducation = {
  outcome: string
  icon: any
  headline: string
  description: string
  recommendedFunnelTypes: string[]
  tips: string[]
}

export const OUTCOME_EDUCATION: OutcomeEducation[] = [
  {
    outcome: 'Grow your audience',
    icon: UsersIcon,
    headline: 'Growing Your Audience',
    description:
      'Building an audience means getting people interested in what you do. The best way is to offer something valuable for free in exchange for their email — then nurture that relationship over time.',
    recommendedFunnelTypes: ['lead', 'challenge'],
    tips: [
      'Start with a Lead Funnel to collect emails with a free guide or checklist.',
      'Use a Challenge Funnel to build community and excitement around a shared goal.',
      'Focus on giving value first — the sales come later.',
    ],
  },
  {
    outcome: 'Generate Leads',
    icon: TargetIcon,
    headline: 'Generating Leads',
    description:
      'Lead generation is about finding people who are a good fit for your offer and getting them into your pipeline. The key is qualifying them early so you spend time on the right people.',
    recommendedFunnelTypes: ['lead', 'appointment'],
    tips: [
      'Use a Lead Funnel to capture contact info with a compelling offer.',
      'Add an Appointment Funnel to qualify leads and book calls with serious prospects.',
      'Always follow up quickly — speed matters in lead conversion.',
    ],
  },
  {
    outcome: 'Host a webinar',
    icon: VideoIcon,
    headline: 'Hosting a Webinar',
    description:
      'Webinars let you teach, build trust, and present your offer to a group — all at once. They work especially well for higher-priced services where people need to see your expertise before buying.',
    recommendedFunnelTypes: ['presentation'],
    tips: [
      'A Presentation Funnel handles registration, reminders, and the replay page.',
      'Teach something genuinely useful in the first 20 minutes before pitching.',
      'Offer a time-limited bonus to encourage action during or right after the webinar.',
    ],
  },
  {
    outcome: 'Sell a digital product',
    icon: PackageIcon,
    headline: 'Selling Digital Products',
    description:
      'Digital products like courses, ebooks, and templates can be sold with a streamlined checkout flow. The key is reducing friction and adding strategic upsells to increase order value.',
    recommendedFunnelTypes: ['product', 'presentation'],
    tips: [
      'A Product Funnel gives you a sales page, checkout, and upsell flow.',
      'For higher-priced digital products, consider a Presentation Funnel to build trust first.',
      'Add an order bump on checkout — it can boost revenue by 20%+.',
    ],
  },
  {
    outcome: 'Sell a physical product',
    icon: BoxIcon,
    headline: 'Selling Physical Products',
    description:
      'Physical product sales benefit from a focused, distraction-free checkout experience. Unlike a full e-commerce store, a funnel guides buyers through one clear path to purchase.',
    recommendedFunnelTypes: ['product'],
    tips: [
      'Use a Product Funnel with a clear sales page and simple checkout.',
      'Show real customer photos and reviews near the buy button.',
      'Offer a complementary product as an upsell right after purchase.',
    ],
  },
  {
    outcome: 'Sell a service',
    icon: BriefcaseIcon,
    headline: 'Selling Services',
    description:
      'Selling services usually requires a conversation. The goal is to attract the right people, qualify them, and get them on a call where you can understand their needs and close the deal.',
    recommendedFunnelTypes: ['appointment', 'lead', 'presentation'],
    tips: [
      'An Appointment Funnel qualifies prospects and books calls automatically.',
      'Start with a Lead Funnel to build trust before asking for a call.',
      'For premium services, a Presentation Funnel can pre-sell your expertise.',
    ],
  },
]
